/**
 * reCAPTCHA feature flag helper.
 *
 * NEXT_PUBLIC_ENABLE_GOOGLE_RECAPTCHA controls whether the Google reCAPTCHA v3
 * script is loaded and tokens are generated. Defaults to false (disabled) if
 * the variable is absent, empty, or not strictly equal to 'true'.
 *
 * This flag was introduced to globally disable reCAPTCHA across PL and RO due
 * to corporate Google account issues. When disabled:
 *   - GoogleReCaptchaProvider is not rendered (no external script download)
 *   - Token generation/polling in use-recaptcha-token.ts returns null immediately
 *   - useSilentSignUp omits the x-recaptcha-token header
 *
 * Re-enable by setting NEXT_PUBLIC_ENABLE_GOOGLE_RECAPTCHA=true in the
 * environment (ADO variable group) — no code changes required.
 */
export const isRecaptchaEnabled = (): boolean =>
  process.env.NEXT_PUBLIC_ENABLE_GOOGLE_RECAPTCHA === 'true';

/**
 * Returns the reCAPTCHA site key only if reCAPTCHA is enabled AND the key is
 * present and non-empty. Use this to guard GoogleReCaptchaProvider mounting.
 */
export const getRecaptchaSiteKey = (): string | null => {
  if (!isRecaptchaEnabled()) return null;

  const key = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
  return key && key.trim() ? key : null;
};
